import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const EmployeeEarningReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [empEarningReport, setEmpEarningReport] = useState([]);
  console.log("empEarningReport",empEarningReport);
  
  const [empList, setEmpList] = useState([]);
  const [YearList, setYearsList] = useState([]);
  const [apiStatus, SetApiStatus] = useState('');
  const [filterFormData, setFilterData] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchIndexApi()
    fetchEmployeeEarningReport();
    dispatch(updateNavbarHeading("Employee Earnings Report"));
  }, []);

  const columns = {
    EmployeeID: { text: "EMP ID", visible: true },
    EmpName: { text: "Name", visible: true },
    Designation: { text: "DESIGNATION", visible: true },
    JoiningDate: { text: "DOJ", align: "center", visible: true },
    RelivingDate : {text: "Rel. Date", align:"center", visible:true},
    TotalExp : {text: "Prev. Exp.", align:"center", visible:true},
    NiceExp : {text: "NICE. Exp.", align:"center", visible:true},
    Gross_Salary: { text: "GROSS", align: "end", visible: true },
    Basic: { text: "BASIC", align: "end", visible: true },
    HRA: { text: "HRA", align: "end", visible: true },
    Spl_Allow: { text: "S. ALLOW", align: "end", visible: true },
    Conv_Allow: { text: "C. ALLOW", align: "end", visible: true },
    LeaveEncash: { text: "Leave Enc.", align: "end", visible: true },
    Consulting_Incentives: { text: "CN Inc.", align: "end", visible: true },
    Content_Incentives: { text: "CT Inc.", align: "end", visible: true },
    Training_Incentives: { text: "TRG Inc.", align: "end", visible: true },
    HR_Incentives: { text: "HR Inc.", align: "end", visible: true },
    CCA: { text: "CCA", align: "end", visible: true },
    Team_Incentive: { text: "TM Inc.", align: "end", visible: true },
    Act_Mng: { text: "Act Mgmt Inc.", align: "end", visible: true },
    Project_Incentives: { text: "Proj Inc.", align: "end", visible: true },
    Incentives: { text: "Inc.", align: "end", visible: true },
    PF: { text: "VPF", align: "end", visible: true },
    Gratuity: { text: "Gratuity", align: "end", visible: true },
    CTC: { text: "CTC", align: "end", visible: true },
    Revenue_Incentives: { text: "Rev. Inc.", align: "end", visible: true },
    Bonus: { text: "J. Bonus", align: "end", visible: true },
    REF_BON: { text: "Ref. Bonus", align: "end", visible: true },
  };
  const formDatas = [
    { name: "Employee List", type: "Select", options: [...empList] },
    { name: "Year", type: "Select", options: [...YearList] },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };




  const fetchIndexApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/calculate-payroll`
      );
      // console.log("check status", response?.status);

      if (response.status === 200) {
        // Shift List
        console.log("response::", response?.data);

        //Employee List
        const employeeList = response?.data?.employeelist
.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmpList(employeeList);

        //Year List
        const yearList = response?.data?.yearlist.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setYearsList(yearList);
        const lastYear = yearList[yearList.length - 1];
        setFilterData((prev) =>
          prev.map((item) =>
            item.label === "Year" ? { ...item, value: lastYear.value } : item
          )
        );
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };
  const fetchEmployeeEarningReport = async () => {
    SetApiStatus(undefined)
    setEmpEarningReport([]);

    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/10?P_Date=&P_empid=`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.filterdata;
        setEmpEarningReport(data);


        
      }
    } catch (error) {
      console.error("Error fetching Employee Earning Report", error);
    }
  };
  const handleGetData = async () => {
    SetApiStatus(undefined)
    setEmpEarningReport([]);
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/10?P_Date=${filterFormData.find((o) => o.label === "Year")
          ? filterFormData.find((o) => o.label === "Year").value
          : ""
        }&P_empid=${filterFormData.find((o) => o.label === "Employee List")
          ? filterFormData.find((o) => o.label === "Employee List").value
          : ""
        }`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.filterdata;
        setEmpEarningReport(data);

        //Employee List
        const employeeList = response?.data?.data?.empList.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmpList(employeeList);

        //Year List
        const yearList = response?.data?.data?.year.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setYearsList(yearList);

        const lastYear = yearList[yearList.length - 1];
        setFilterData((prev) =>
          prev.map((item) =>
            item.label === "Year" ? { ...item, value: lastYear.value } : item
          )
        );
      }
    } catch (error) {
      console.error("Error fetching Employee Earning Report", error);
    }
  };





  const handleReset = () => {
    setFilterData([])
    fetchEmployeeEarningReport()
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={empEarningReport}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              handleReset={handleReset}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              isSorting={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeEarningReport;
